<template>
  <b-card>
    <div style="font-size: 12px">
      <div class="title">
        <span>Cadastro de Produto</span>
      </div>
      <div class="rowContainer">
        <div style="display: flex; justify-content: space-between">
          <span>
            <b-icon-box-seam />
            Informações Gerais
          </span>

          <div
            :style="`
              background-color: ${
                dataProducts.tipoProduto === 'agrotoxico' ? '#006256' : 'gray'
              } ;
              border-radius: 8px;
              padding: 0.1rem 0.5rem;
            `"
          >
            <p style="margin: 0; color: white; font-size: 12px">
              {{
                dataProducts.tipoProduto === "agrotoxico"
                  ? "AGROTÓXICO"
                  : "NORMAL"
              }}
            </p>
          </div>
        </div>

        <div class="product-identification-grid">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataProducts.nome"
              :disabled="dataProducts.tipoProduto === 'agrotoxico'"
            />
            <label class="fixedSelect2"> Nome </label>
          </div>
          <div class="input-group">
            <input
              type="date"
              class="input borderInput"
              v-model="dataProducts.dtValidade"
            />
            <label class="user-label"> Data Validade </label>
          </div>
        </div>

        <div class="product-values-section">
          <span><b-icon-cash /> Valores e formação do preço</span>
          <div class="product-values-grid">
            <div class="input-group">
              <b-form-input
                required
                class="input borderInput"
                :value="maskCurrency(dataProducts.valor)"
                @input="calculateValue($event)"
              />
              <label class="user-label"> Valor de Custo </label>
            </div>

            <div class="input-group">
              <b-form-input
                class="input borderInput"
                :value="maskPercentage(dataProducts.margem1)"
                @input="calculateProfitMargin($event)"
              />
              <label class="user-label"> % Margem de Lucro </label>
            </div>
            <div class="input-group">
              <b-form-input
                class="input borderInput"
                :value="maskCurrency(dataProducts.lucro)"
                @input="calculateProfit($event)"
              />
              <label class="user-label"> V. Lucro </label>
            </div>

            <div class="input-group">
              <b-form-input
                required
                class="input borderInput"
                :value="maskCurrency(dataProducts.valorVenda)"
                @input="calculateValueSale($event)"
              />
              <label class="user-label"> Valor de Venda </label>
            </div>
            <div class="product-discount-field">
              <InputMoney
                v-if="!discountIsCheked"
                label="Desconto"
                :labelFixed="true"
                type="text"
                :dataInput.sync="desconto"
                ref="discount"
                @calculateTotal="handleCalculateTotal"
              />

              <InputPercentage
                v-else
                label="Desconto"
                :labelFixed="true"
                type="text"
                :dataInput.sync="desconto"
                ref="discount"
                @calculateTotal="handleCalculateTotal"
              />
              <div class="product-discount-toggle">
                <label class="switch">
                  <input
                    type="checkbox"
                    ref="typeDiscount"
                    @click="alterDiscountIsCheked"
                    v-model="discountIsCheked"
                  />
                  <div class="slider">
                    <span>R$</span>
                    <span>%</span>
                  </div>
                </label>
              </div>
            </div>
            <InputMoney
              label="Valor Com Desconto"
              labelFixed
              ref="valorComDesconto"
              type="text"
              isDisabled
              :dataInput.sync="dataProducts.valorDesconto"
              @calculateTotal="handleCalculateTotal"
            />
          </div>
        </div>

        <div v-if="dataProducts.tipoProduto === 'agrotoxico'">
          <hr style="margin: 0.5rem 0" />

          <div>
            <span> Informações Específicas para agrotóxicos</span>
          </div>

          <div class="rowContent" style="justify-content: normal">
            <div class="input-group" style="flex: 1 1 auto; max-width: 180px">
              <input
                required
                class="input borderInput"
                v-model="dataProducts.embalagem"
                :disabled="dataProducts.tipoProduto === 'agrotoxico'"
              />
              <label class="fixedSelect2"> Embalagem </label>
            </div>

            <div class="input-group" style="flex: 1 1 auto; max-width: 180px">
              <input
                required
                class="input borderInput"
                :value="dataProducts.lote || 'Não Informado'"
                :disabled="dataProducts.tipoProduto === 'agrotoxico'"
              />
              <label class="fixedSelect2"> Lote </label>
            </div>

            <div class="input-group" style="flex: 1 1 auto; max-width: 180px">
              <input
                required
                class="input borderInput"
                v-model="dataProducts.registroAgrotox"
                :disabled="dataProducts.tipoProduto === 'agrotoxico'"
              />
              <label class="fixedSelect2"> Número de Registro </label>
            </div>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span>
          <b-icon-card-checklist></b-icon-card-checklist> Estoque e
          identificação
        </span>
        <div class="rowContent">
          <div class="input-group" style="width: 30%">
            <input
              required
              class="input borderInput"
              v-model="dataProducts.codBarras"
            />
            <label class="user-label"> Cód de Barras </label>
          </div>
          <InputSelect
            label="Categorias"
            :items="categories"
            valueField="id"
            textField="nome"
            :dataSelect.sync="dataProducts.idCategoria"
            :openCreateModal="() => openModals('modalCategories')"
            ref="refCategories"
          />
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataProducts.codReferencia"
            />
            <label class="user-label"> Cód de Referência</label>
          </div>
          <div class="input-group" style="width: 10%">
            <input
              disabled
              class="input borderInput"
              v-model="dataProducts.estoque"
              type="number"
            />
            <label class="fixedSelect2"> Estoque </label>
          </div>
          <div class="input-group" style="width: 15%">
            <input
              required
              class="input borderInput"
              v-model="dataProducts.estoqueMin"
            />
            <label class="user-label"> Estoque Minímo </label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">Unidade</label>
            <b-form-select
              class="borderInput shadow-none"
              value-field="value"
              text-field="text"
              :options="unidade"
              v-model="dataProducts.unidade"
            >
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span>
          <b-icon-journal-code></b-icon-journal-code> Informações Fiscais</span
        >
        <div class="rowContentNcm">
          <InputInfinit
            label="Lista de NCM"
            typeFilter="ncm"
            value="codigo_ncm"
            text="nomeNcm"
            :isEdit="dataProducts.ncm"
            :dataInput.sync="dataProducts.ncm"
            :onSearch="fillNcmComboBoxWithPaginate"
            :openCreateModal="() => openModals('modalNcms')"
            :findAll="reloadNcms"
            :searchFields="['codigo_ncm', 'descricao']"
          />
          <b-button
            class="questionNcmBtn"
            v-b-popover.hover.top="
              'O NCM é uma classificação de oito dígitos usada para categorizar produtos em transações comerciais dentro do Mercosul. Essencial para determinar impostos e tarifas de importação. Exemplo : 9503.60.00'
            "
          >
            <b-icon-question-circle-fill scale="1.2" />
          </b-button>
        </div>
        <div class="rowContent">
          <div class="selectPlus">
            <label class="fixedSelect2">Lista de CEST</label>
            <b-form-select
              class="borderInput shadow-none"
              value-field="cest"
              text-field="nomeCest"
              :options="cests"
              v-model="dataProducts.cest"
            >
            </b-form-select>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataProducts.nomeCest"
            />
            <label class="user-label"> Descrição CEST </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataProducts.cest"
              @input="handleNcmOrCest(dataProducts.cest)"
            />
            <label class="user-label"> Novo CEST </label>
            <b-button
              class="questionBtn"
              v-b-popover.hover.top="
                'O CEST é um código numérico que identifica produtos sujeitos à substituição tributária, facilitando o cálculo de impostos sobre eles. Exemplo : 28.064.00'
              "
            >
              <b-icon-question-circle-fill scale="1.2" />
            </b-button>
          </div>
        </div>
        <div class="rowRefFiscal">
          <div class="input-group-ob">
            <InputInfinit
              label="REF. Fiscal"
              typeFilter="refFiscal"
              value="ref"
              text="nomeRef"
              :isEdit="dataProducts.refFiscal"
              :dataInput.sync="dataProducts.refFiscal"
              :onSearch="fillRefsFiscaisComboBoxWithPaginate"
              :enableIconCreate="false"
              :findAll="createdNewRef"
              :searchFields="['ref', 'descricao']"
              :additionalFilters="refFiscalFilters"
              @openFilters="loadRefFiscalCategories"
            />
          </div>
          <div style="width: 30%" class="refFiscalMobile">
            <b-button
              class="btnsRefFiscal"
              @click="openModals('modalTaxInformation')"
            >
              <b-icon-plus-square></b-icon-plus-square> Nova Info.Fiscal
            </b-button>
          </div>
        </div>
      </div>

      <div class="rowContainer" style="margin-bottom: 50px">
        <span> <b-icon-info-circle></b-icon-info-circle> Observações </span>
        <div class="rowObservation">
          <div class="input-group-ob">
            <input
              required
              class="input borderInput"
              v-model="dataProducts.descricao"
            />
            <label class="user-label-ob"> Observações </label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">Status</label>
            <b-form-select
              class="borderInput shadow-none"
              value-field="value"
              text-field="text"
              :options="status"
              v-model="dataProducts.status"
              :disabled="!this.dataProducts.id"
            >
            </b-form-select>
          </div>
        </div>
        <div class="btnsContainer">
          <b-button class="btnsSaveNeutral" @click="clear"
            >Novo <b-icon-arrow-clockwise class="ml-1"></b-icon-arrow-clockwise
          ></b-button>
          <div class="d-flex justify-content-end">
            <div
              v-if="
                !stockAdjustmentIsEnable &&
                dataProducts.tipoProduto !== 'agrotoxico'
              "
            >
              <b-button
                v-b-modal.modal-ajustStock
                style="background: #00aa62"
                class="btnsSave"
                ><b-icon-plus scale="1.5"></b-icon-plus> Ajustar estoque
              </b-button>
            </div>
            <!-- <div class="ajustStock">
              <div style="width: 90px" v-if="stockAdjustmentIsEnable">
                <b-form-input
                  id="input-1"
                  required
                  v-model="stockAmount"
                  size="sm"
                  type="number"
                ></b-form-input>
              </div>

              <div v-if="stockAdjustmentIsEnable" class="contentIconsStock">
                <div class="contentIcons">
                  <b-icon-check-circle-fill
                    class="iconsStockConfirm"
                    role="button"
                    scale="2"
                    @click="handleStockAdjustment"
                  />
                </div>

                <div class="contentIcons">
                  <b-icon-x-circle-fill
                    class="iconsStockCancel"
                    role="button"
                    scale="2"
                    @click="closeStockAdjustment"
                  />
                </div>
              </div>
            </div> -->
          </div>
          <b-button
            class="btnsSave"
            @click="saveOrUpdateProducts"
            :disabled="isLoading"
          >
            {{ dataProducts.id ? "Atualizar" : "Salvar" }}

            <div
              v-if="isLoading"
              style="
                position: absolute;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                width: 100%;
                height: 100%;
                top: 0px;
                right: 20px;
              "
            >
              <b-spinner small label="Small Spinner"></b-spinner>
            </div>

            <b-icon-check2-circle class="ml-1" />
          </b-button>
        </div>
      </div>

      <ModalTaxInformation @createdNewRef="createdNewRef = $event" />
      <ModalCreateCategory @getNewCategory="findAllCategories" />
      <ModalCreateNcm @getNewNcm="reloadNcms = !reloadNcms" />

      <b-modal
        id="modal-ajustStock"
        hide-footer
        hide-header
        centered
        title="Stock"
      >
        <div>
          <h6 class="titleModal">Digite a nova quantidade do estoque:</h6>
          <div class="contentModal">
            <div class="input-group" style="width: 45%">
              <b-form-input
                required
                class="input borderInput"
                v-model="stockAmount"
              />
              <label class="user-label"> Novo Estoque </label>
            </div>

            <div class="input-group" style="width: 45%">
              <b-form-input
                required
                disabled
                class="input borderInput"
                v-model="dataProducts.estoque"
              />
              <label class="fixedSelect2"> Estoque Atual </label>
            </div>
          </div>
          <div class="btnModal">
            <button class="btnContent" @click="handleStockAdjustment">
              Atualizar Estoque
            </button>
            <button
              class="btnContentReceive"
              @click="$bvModal.hide('modal-ajustStock')"
            >
              Cancelar
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import mixinProducts from "../../mixins/Products/Products";
export default {
  mixins: [mixinProducts],
};
</script>
<style scoped>
.containerCard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  padding: 0px 0px 20px 0px;
  border-bottom: 1px solid rgb(231, 231, 231);
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
  color: red !important;
  border: none !important;
}

.custom-select-sm {
  height: 28px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 12px;
}

.contentIconsStock {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  max-height: 29px;
  width: 71px;
}

.contentIcons {
  height: 100%;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iconsStockCancel {
  color: red;
}
.iconsStockConfirm {
  color: #00aa62;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  z-index: 30;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.inputDisabled {
  background-color: #fafafa;
  pointer-events: none;
  color: #949290 !important;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.form-control:focus {
  background-color: #ffffff00;
  box-shadow: none !important;
  border: 1px solid black !important;
}

.form-control {
  border-radius: 5px !important;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.questionBtn {
  display: flex;
  justify-content: center;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}
.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}
.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 24px;
  left: 20px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: transparent;
}
.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  font-weight: 600;
}

.rowContainer {
  position: relative;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContainerComposition {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 10px 10px 5px 10px;
  margin-bottom: 10px;
  transition: ease-in all 0.3s;
  /* margin-left: 3rem; */
}

.rowContainerComposition span {
  font-weight: 600;
  font-size: 11px;
}

.contentModal {
  display: flex;
  padding: 15px 0px 5px 0px;
  justify-content: space-around;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.rowContentNcm {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: flex-start;
  gap: 10px;
}

.questionNcmBtn {
  display: flex;
  justify-content: center;
  height: 30px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.product-identification-grid,
.product-values-grid {
  display: grid;
  gap: 15px;
  padding: 15px 0 5px;
}

.product-identification-grid {
  grid-template-columns: 2fr 1fr;
}

.product-values-section {
  border-top: 1px solid #e6e6e6;
  margin-top: 10px;
  padding-top: 10px;
}

.product-values-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.product-identification-grid .input-group,
.product-values-grid .input-group {
  width: 100%;
  min-width: 0;
}

.product-discount-field {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.product-discount-toggle {
  flex: 0 0 52px;
  height: 30px;
}

.product-discount-toggle .switch {
  width: 100%;
}
.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
  gap: 30px;
}

.rowRefFiscal {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  min-height: 40px;
  gap: 30px;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.btnContainerComposition {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.btnsAddComposition {
  display: flex;
  align-items: center;
  position: absolute;
  top: 5px;
  right: 10px;
  border-radius: 5px;
  background-color: #006256;
  border: none;
  color: white;
  font-size: 11px;
  padding: 0.1rem 0.8rem;
}

.btnsSave {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
  font-weight: 600;
  position: relative;
}

.ajustStock {
  display: flex;
  margin-top: 30px;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #f9f9f9;
  width: 165px;
  border: 1px solid gray;
  margin-top: 30px;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}
.btnsRefFiscal {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 100%;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.input-group {
  width: 30%;
}

.input-group-ob {
  width: 70%;
}

.input-group-stock {
  width: 70%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

.enabledComposition {
  display: block;
}

.closeComposition {
  display: none;
  overflow: hidden;
}

@media screen and (max-width: 700px) {
  .product-identification-grid,
  .product-values-grid {
    grid-template-columns: 1fr;
  }

  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .input-group {
    width: 100%;
  }

  .input-group-ob {
    width: 50%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }

  .refFiscalMobile {
    width: 50% !important;
  }

  .btn {
    padding: 0.375rem 0.5rem;
  }
}
</style>
